'use strict';

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _reactHotLoader = require('react-hot-loader');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _trcBrowserDetection = require('trc-browser-detection');

var _trcBrowserDetection2 = _interopRequireDefault(_trcBrowserDetection);

var _core = require('jquery/src/core');

var _core2 = _interopRequireDefault(_core);

require('jquery/src/attributes/classes');

require('jquery/src/css');

require('jquery/src/dimensions');

require('jquery/src/offset');

require('jquery/src/effects');

require('core-js/fn/array/find');

require('core-js/fn/array/find-index');

require('core-js/fn/array/from');

var _set = require('core-js/fn/set');

var _set2 = _interopRequireDefault(_set);

var _promise = require('core-js/es6/promise');

var _promise2 = _interopRequireDefault(_promise);

require('whatwg-fetch');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!window.process) window.process = {};

// import $ from 'jquery';

window.$ = _core2.default;

// shims and global dependencies


// window.fetch


window.Set = _set2.default;
window.Promise = _promise2.default;

/**
 * Hack in support for Function.name for browsers that don't support it.
 * IE, I'm looking at you.
**/
if (Function.prototype.name === undefined && _defineProperty2.default !== undefined) {
  Object.defineProperty(Function.prototype, 'name', {
    get: function get() {
      var funcNameRegex = /function\s([^(]{1,})\(/;
      var results = funcNameRegex.exec(this.toString());
      return results && results.length > 1 ? results[1].trim() : "";
    },
    set: function set(value) {}
  });
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.lastIndexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

// sets the server path for all resources in case of dynamic reassignment
if (window.assetServer) __webpack_public_path__ = window.assetServer;

// Get the root element from the HTML
var rootEl = document.getElementById("applicationHost");
var render = function render(Component, application) {
  return _reactDom2.default.render(_react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_trcBrowserDetection2.default, null),
    _react2.default.createElement(
      _reactHotLoader.AppContainer,
      null,
      _react2.default.createElement(Component, { application: application })
    )
  ), rootEl);
};

// branch bundle, necessary for dynamic resource path assignment (window.assetServer)
require.ensure(['./project-layout', './app'], function () {
  var LayoutComponent = require('./project-layout').default;
  var Application = require('./app').default;

  // @TODO: replace {mock: true} with webpack injected arg
  var application = window.application = new Application({ mock: true });

  render(LayoutComponent, application);

  // setup proper hot module replacement
  if (module.hot) {
    module.hot.accept("./project-layout", function () {
      return render(require('./project-layout').default, application);
    });
    module.hot.accept("./app", function () {
      var Application = require('./app').default;
      var application = window.application = new Application();
      render(LayoutComponent, application);
    });
  }
});
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(rootEl, 'rootEl', 'src/core_modules/authoring-application/entry.js');

  __REACT_HOT_LOADER__.register(render, 'render', 'src/core_modules/authoring-application/entry.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/authoring-application/entry.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/authoring-application/entry.js
// module chunks = 2